import { render, staticRenderFns } from "./MemberIdentityVerification.vue?vue&type=template&id=14171d18&"
import script from "./MemberIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./MemberIdentityVerification.vue?vue&type=script&lang=js&"
import style0 from "./MemberIdentityVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports